import { FC } from "react";
import { AppMenuKey, AppMenuSectionItem } from "../common/routesUtils";
import { View } from "../components/layout/View";
import { PageType } from "../config/page.types";

interface Props {
	pageType: PageType;
	text: string;
	menuKeys?: Array<AppMenuKey>;
	path?: Array<AppMenuSectionItem>;
}

/**
 * PlaceholderView renders a placeholder view that can be used for temporary or debugging reasons.
 *
 * @returns a placeholder view.
 */
const PlaceholderView: FC<Props> = ({ pageType, text }) => {
	return <View pageType={pageType}>{text}</View>;
};

export default PlaceholderView;
